import React from "react";
import { Snackbar, makeStyles } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme) => ({
  snackBar: {
    width: "300px",
  },
  snackBarError: {
    width: "300px",
    backgroundColor: "#f44336 !important",
  },
}));

export default function SimpleSnackbar(props) {
  const { open, severity, time, onClose, message, data } = props;
  const classes = useStyles();
  // const [open, setOpen] = React.useState(false);

  // const handleClick = () => {
  //   setOpen(true);
  // };

  // const handleClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }

  //   setOpen(false);
  // };

  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={open}
        autoHideDuration={time}
        onClose={onClose}
      >
        <Alert
          onClose={onClose}
          variant="filled"
          severity={severity}
          className={
            severity === "error"
              ? `${classes.snackBarError} text-center`
              : `${classes.snackBar} text-center`
          }
        >
          {message}
          {severity === "error" ? (
            <></>
          ) : (
            <>
              <div>{`代號:  ${data.freightCode}`}</div>
              <div>{`貨運公司名稱:  ${data.freightName}`}</div>
            </>
          )}
        </Alert>
      </Snackbar>
    </div>
  );
}
